var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"co button round",class:( _obj = {}, _obj[("" + (this.variant))] = true, _obj.disabled = _vm.disabled, _obj ),attrs:{"disabled":_vm.disabled},on:{"click":_vm.click}},[_c('CoIcon',{attrs:{"name":_vm.icon,"size":_vm.iconSize}}),(_vm.badge)?_c('span',{staticClass:"counter"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }